// React
import React from "react";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class IFrameView extends React.Component {
    render() {
        let { url } = this.props;
        return (React.createElement("iframe", { src: url }));
    }
}
